import { useEffect, useRef } from 'react';

/** Calls `onDismiss` on a mouse press outside `ref` while `isOpen`. */
export const useDismissOnOutsideClick = (ref, isOpen, onDismiss) => {
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleMouseDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) onDismissRef.current();
    };
    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, [ref, isOpen]);
};
